import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { AmcAnalysisTemplate } from "@front/m19-api-client";
import { ICheckboxComponent, ILabelComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

export interface AmcAnalysisTemplateModel {
  templates: AmcAnalysisTemplate[];
  brandKeywords: string[];
}

@Component({
  selector: "app-amc-analysis-template-step",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, ICheckboxComponent, ILabelComponent],
  host: { class: "block h-full" },
  template: `<div class="flex h-full min-h-0 flex-col gap-6 py-8" *transloco="let t">
    <div class="flex shrink-0 flex-col gap-1">
      <h4>{{ t("common.template") }}</h4>
      <p class="text-muted-foreground m-0">{{ t("amc.strategy_analysis_template_description") }}</p>
    </div>
    <div class="grid min-h-0 flex-1 grid-cols-1 content-start gap-2 overflow-y-auto">
      @for (option of options(); track option) {
        <label iLabel type="card" class="relative w-full rounded-lg border p-4" [for]="option">
          <ICheckbox
            [inputId]="option"
            inputName="amcAnalysisTemplates"
            [value]="selected().has(option)"
            (valueChange)="toggle(option, $event)"
          />
          <div class="flex flex-col gap-1 pr-6">
            <span class="type-body-medium">{{ t("amc-analysis-template." + option) }}</span>
            <p class="text-muted-foreground m-0">
              {{ t("amc-analysis-template." + option + "_DESCRIPTION") }}
            </p>
          </div>
        </label>
      }
    </div>
  </div>`,
})
export class AmcAnalysisTemplateStepComponent {
  readonly template = input.required<FieldTree<AmcAnalysisTemplateModel>>();
  readonly options = input.required<AmcAnalysisTemplate[]>();

  readonly selected = computed(() => new Set(this.template().templates().value()));

  toggle(template: AmcAnalysisTemplate, checked: boolean) {
    const templates = this.template().templates().value();
    this.template()
      .templates()
      .value.set(checked ? [...templates, template] : templates.filter((t) => t !== template));
  }
}
